import { combineReducers } from 'redux';

import { adminAIQueriesReducer } from '../queries/store/reducer';
import { adminAIPlaygroundReducer } from '../playground/store/reducer';
import { adminAIChatbotReducer } from '../chatbot/store/reducer';
import { fewShotDocumentsReducer } from '../few-shot/store/reducer';

export const adminAIReducer = combineReducers({
    queries: adminAIQueriesReducer,
    playground: adminAIPlaygroundReducer,
    chatbot: adminAIChatbotReducer,
    fewShotDocuments: fewShotDocumentsReducer
});
